require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./effectif-des-diplms-2-0-4-1.json") })
        }
      }, "path---effectif-des-diplms-2-0-4-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---effectif-des-diplms-2-0-4-1!./.cache/json/effectif-des-diplms-2-0-4-1.json
// module id = 403
// module chunks = 231608221292675